import {OpenFeature} from '@openfeature/web-sdk';

export const useFeatureFlag = () => {
  const client = OpenFeature.getClient();

  const isFeatureActive = (flag: string, defaultValue = false): boolean => {
    return client.getBooleanValue(flag, defaultValue);
  };

  return {isFeatureActive};
};
